import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconChevronLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "#000000",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z" }), /* @__PURE__ */ _jsx("path", {
		d: "M0-.5h24v24H0z",
		fill: "none"
	})]
});
export default SvgIconChevronLeft;
